import {
  EDIT_CHARTCOLOR,
  LIST_CHARTCOLOR,
  CHARTCOLOR_SUCCESS,
  CHARTCOLOR_ERROR,
} from "./actionTypes";

const initialState = {
  editLoading: false,  // Separate loading state for editing
  loading: false,  // Separate loading state for listing
  successMsg: null,
  error: null,
};

const configurationsChartcolor = (state = initialState, action) => {
  switch (action.type) {
      case EDIT_CHARTCOLOR:
          return {
              ...state,
              editLoading: true,  // Set edit loading to true
              successMsg: null,
              error: null,
          };

      case LIST_CHARTCOLOR:
          return {
              ...state,
              loading: true,  // Set list loading to true
              successMsg: null,
              error: null,
          };

      case CHARTCOLOR_SUCCESS:
          // Determine which loading state to reset based on the action payload
          return {
              ...state,
              editLoading: false,  // Reset edit loading to false
              loading: false,  // Reset list loading to false
              successMsg: action.payload,
              error: null,  // Clear any errors on success
          };

      case CHARTCOLOR_ERROR:
          // Reset both loading states on error
          return {
              ...state,
              editLoading: false,  // Reset edit loading to false
              loading: false,  // Reset list loading to false
              error: action.payload,
              successMsg: null,  // Clear success message on error
          };

      default:
          return state;  // Return current state for unhandled actions
  }
};

export default configurationsChartcolor;
